export interface UserManualOptions {
  version?: string; // 특정 섹션 버전 (해당 섹션의 첫 페이지로 점프)
  baseVersion?: string; // 사용자의 현재 manualVersion (내부에서 시작 페이지 자동 계산)
  shouldUpdateVersion?: boolean; // 자동 팝업 시 true, 수동 팝업 시 false
}

type UserManualState = {
  visible: boolean;
  options: UserManualOptions | null;
};

type Listener = (state: UserManualState) => void;

class UserManualManagerClass {
  private static instance: UserManualManagerClass;
  private listeners: Listener[] = [];
  private state: UserManualState = {
    visible: false,
    options: null,
  };

  private constructor() {}

  static getInstance(): UserManualManagerClass {
    if (!UserManualManagerClass.instance) {
      UserManualManagerClass.instance = new UserManualManagerClass();
    }
    return UserManualManagerClass.instance;
  }

  addListener(listener: Listener): void {
    this.listeners.push(listener);
  }

  removeListener(listener: Listener): void {
    this.listeners = this.listeners.filter((l) => l !== listener);
  }

  show(options: UserManualOptions = {}): void {
    this.state = {
      visible: true,
      options,
    };
    this.notifyListeners();
  }

  hide(): void {
    this.state = {
      ...this.state,
      visible: false,
    };
    this.notifyListeners();
  }

  private notifyListeners(): void {
    this.listeners.forEach((listener) => listener(this.state));
  }
}

export const UserManualManager = UserManualManagerClass.getInstance();
